(() => {
  if (customElements.get('corner-arrivals-autoplay')) return;
  customElements.define('corner-arrivals-autoplay', class extends HTMLElement {
    connectedCallback() {
      this.stop();
      this.events = new AbortController();
      const signal = this.events.signal;
      this.track = this.querySelector('[data-corner-rail-track]');
      if (!this.track) return;
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.visible = this.hovered = this.focused = this.held = false;
      this.direction = 1;
      this.position = this.track.scrollLeft;
      this.speed = 0;
      this.last = 0;
      this.resumeAt = performance.now() + 1200;
      const delay = () => { this.resumeAt = performance.now() + 600; this.speed = 0; };
      const release = () => { if (this.held) { this.held = false; delay(); } };
      this.track.addEventListener('pointerdown', () => { this.held = true; delay(); }, { signal, passive:true });
      window.addEventListener('pointerup', release, { signal, passive:true });
      window.addEventListener('pointercancel', release, { signal, passive:true });
      this.track.addEventListener('touchstart', () => { this.held = true; delay(); }, { signal, passive:true });
      this.track.addEventListener('touchend', release, { signal, passive:true });
      this.track.addEventListener('touchcancel', release, { signal, passive:true });
      this.track.addEventListener('wheel', e => { if (Math.abs(e.deltaX) > Math.abs(e.deltaY)) delay(); }, { signal, passive:true });
      this.addEventListener('keydown', delay, { signal });
      this.track.addEventListener('pointerenter', e => { if (e.pointerType === 'mouse' && matchMedia('(hover: hover) and (pointer: fine)').matches) this.hovered = true; }, { signal });
      this.track.addEventListener('pointerleave', () => { if (this.hovered) { this.hovered = false; delay(); } }, { signal });
      this.track.addEventListener('focusin', e => { this.focused = e.target.matches(':focus-visible'); if (this.focused) delay(); }, { signal });
      this.track.addEventListener('focusout', e => { if (this.focused) { this.focused = !!e.relatedTarget && this.track.contains(e.relatedTarget) && e.relatedTarget.matches(':focus-visible'); delay(); } }, { signal });
      document.addEventListener('visibilitychange', () => { this.held = false; delay(); }, { signal });
      this.motion.addEventListener('change', delay, { signal });
      this.observer = new IntersectionObserver(entries => {
        this.visible = entries[0].isIntersecting && entries[0].intersectionRatio >= .25;
        this.resumeAt = performance.now() + 1200;
      }, { threshold:[0,.25] });
      this.observer.observe(this.track);
      this.tick = now => { this.advance(now); this.frame = requestAnimationFrame(this.tick); };
      this.frame = requestAnimationFrame(this.tick);
    }
    advance(now) {
      const dt = this.last ? Math.min(34, now - this.last) / 1000 : 0;
      this.last = now;
      if (this.motion.matches || !this.visible || document.hidden || this.hovered || this.focused || this.held || now < this.resumeAt) {
        this.position = this.track.scrollLeft;
        this.speed = 0;
        return;
      }
      const end = this.track.scrollWidth - this.track.clientWidth;
      if (end <= 1) return;
      // Retain fractional pixels rather than losing subpixel movement to scrollLeft rounding.
      if (Math.abs(this.track.scrollLeft - this.position) > 2) this.position = this.track.scrollLeft;
      this.speed += (22 - this.speed) * Math.min(1, dt * 3);
      this.position += this.speed * dt;
      const first = this.track.firstElementChild;
      const step = first.getBoundingClientRect().width + (parseFloat(getComputedStyle(this.track).columnGap) || 0);
      if (step > 0 && this.position >= step) {
        this.track.append(first);
        this.position -= step;
      }
      this.track.scrollLeft = this.position;
    }
    stop() {
      this.events?.abort();
      this.observer?.disconnect();
      cancelAnimationFrame(this.frame);
    }
    disconnectedCallback() { this.stop(); }
  });
})();
